module.exports = __webpack_public_path__ + "static/media/masBeneficios.3c1d9391.png";